import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import useFetchWithAuth from "../features/hooks/useFetchWithAuth";
import { canAccess, getRules } from "../util/rbac";

const getRoleHomePath = (data) => {
  const role = String(
    data?.access_role?.associated_role ||
      data?.access_role?.name ||
      data?.role?.associated_role ||
      data?.role?.name ||
      data?.role ||
      ""
  )
    .trim()
    .toLowerCase();

  if (role.includes("management") || role.includes("manager")) {
    return "/management/dashboard";
  }
  if (role.includes("supervisor")) {
    return "/supervisor/dashboard/";
  }
  if (role.includes("operator")) {
    return "/operator/dashboard";
  }

  return "/login";
};

const ProtectedRoute = ({ resource, method = "GET", children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data, loading, error } = useFetchWithAuth("/user/me/");

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (error || !data) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const rules = getRules(data);
  const hasAccess = canAccess(rules, resource, method);
  if (!hasAccess) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 8,
          gap: 1,
        }}
      >
        <Typography variant="h4" align="center">
          403
        </Typography>
        <Typography align="center">Немає прав доступу.</Typography>
        <Button
          variant="contained"
          startIcon={<HomeOutlinedIcon />}
          onClick={() => navigate(getRoleHomePath(data))}
          sx={{ mt: 2 }}
        >
          Повернутися на головну
        </Button>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
